var map = {
	"./BI.png": 638,
	"./Baas.png": 9398,
	"./BigData.png": 1659,
	"./Blockchain.png": 2307,
	"./IdentityResolution.png": 3426,
	"./IntelligentVision.png": 5930,
	"./Lcode.png": 3422,
	"./MechanismModel.png": 3278,
	"./OpenAPI.png": 7921
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2846;